import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../../assets/models/subtopicOne/GLB_Ciudad_V4.glb";
import rayos from "../../../../../assets/models/subtopicOne/GLB_Rayos_V2.glb";
import modelbackground from "../../../../../assets/models/subtopicOne/GLB_Background.glb";
import gsap from "gsap";

export class City extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.scale.set(2, 2, 2);
		this.objectActiveAnimation = null
		// this.rotation.y = MathUtils.degToRad(90)
	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);
			this.OXXO_PARADA_TECNICA = gltf.scene.getObjectByName("OXXO_HOGAR_REUNION001", true);
			this.OXXO_OFICINA = gltf.scene.getObjectByName("OXXO_OFICINA", true);
			this.OXXO_HOGAR_REUNION = gltf.scene.getObjectByName("OXXO_HOGAR_REUNION", true);
			this.OXXO_CLASICO = gltf.scene.getObjectByName("OXXO_CLASICO", true);
			this.OXXO_BARRIO = gltf.scene.getObjectByName("OXXO_BARRIO", true);

			//*iluminacion
			this.taxi_LP003 = gltf.scene.getObjectByName("taxi_LP003", true);
			this.taxi_LP003.material.emissiveIntensity = 1;
			this.taxi_LP003.material.emissive.set("#ABABAB"); // 171

			this.Tienda_Azul_LP001 = gltf.scene.getObjectByName("Tienda_Azul_LP001", true);
			this.Tienda_Azul_LP001.material.emissiveIntensity = 1;
			this.Tienda_Azul_LP001.material.emissive.set("#B0B0B0"); // 176

			this.Cube108 = gltf.scene.getObjectByName("Cube108", true);
			this.Cube108.material.emissiveIntensity = 1;
			this.Cube108.material.emissive.set("#AEAEAE"); // 174

			// this.tree_large_mesh005 = gltf.scene.getObjectByName("tree_large_mesh005", true); // nombre diferente
			// this.tree_large_mesh005.material.emissiveIntensity = 0;
			// // this.tree_large_mesh005.material.emissive.set("#E8E8E8"); // 232
			// this.tree_large_mesh005.material.color.set(0xE8E8E8)

			this.CASA_AZUL_LP001 = gltf.scene.getObjectByName("CASA_AZUL_LP001", true);
			this.CASA_AZUL_LP001.material.emissiveIntensity = 1;
			this.CASA_AZUL_LP001.material.emissive.set("#A3A3A3"); // 163

			this.Tienda_Verde_LP002 = gltf.scene.getObjectByName("Tienda_Verde_LP002", true);
			this.Tienda_Verde_LP002.material.emissiveIntensity = 1;
			this.Tienda_Verde_LP002.material.emissive.set("#FFFFFF");

			this.Tienda_Verde_LP001 = gltf.scene.getObjectByName("Tienda_Verde_LP001", true);
			this.Tienda_Verde_LP001.material.emissiveIntensity = 1;
			this.Tienda_Verde_LP001.material.emissive.set("#BDBDBD"); //189

			this.Tienda_Azul_LP002 = gltf.scene.getObjectByName("Tienda_Azul_LP002", true);
			this.Tienda_Azul_LP002.material.emissiveIntensity = 1;
			this.Tienda_Azul_LP002.material.emissive.set("#CBC8C8"); // 203, 200, 200

			this.GYM_LP001 = gltf.scene.getObjectByName("GYM_LP001", true);
			this.GYM_LP001.material.emissive.set("#BDBDBD"); //189

			this.CASA_AMARILLA_LP004 = gltf.scene.getObjectByName("CASA_AMARILLA_LP004", true);
			this.CASA_AMARILLA_LP004.material.emissiveIntensity = 1;
			this.CASA_AMARILLA_LP004.material.emissive.set("#A3A3A3"); //163

			this.CASA_AZUL_LP005 = gltf.scene.getObjectByName("CASA_AZUL_LP005", true);
			this.CASA_AZUL_LP005.material.emissiveIntensity = 1;
			this.CASA_AZUL_LP005.material.emissive.set("#ADADAD"); //173

			this.COFFE_LP002 = gltf.scene.getObjectByName("COFFE_LP002", true);
			this.COFFE_LP002.material.emissiveIntensity = 1;
			this.COFFE_LP002.material.emissive.set("#7D7D7D"); //125

			this.CASA_ROJA_LP001 = gltf.scene.getObjectByName("CASA_ROJA_LP001", true);
			this.CASA_ROJA_LP001.material.emissiveIntensity = 1;
			this.CASA_ROJA_LP001.material.emissive.set("#707070"); //112

			this.carro_azul_LP007 = gltf.scene.getObjectByName("carro_azul_LP007", true);
			this.carro_azul_LP007.material.emissiveIntensity = 1;
			this.carro_azul_LP007.material.emissive.set("#8C8C8C"); //140

			this.SUPER_LP001 = gltf.scene.getObjectByName("SUPER_LP001", true);
			this.SUPER_LP001.material.emissiveIntensity = 4;

			this.carro_rojo_LP008 = gltf.scene.getObjectByName("carro_rojo_LP008", true);
			this.carro_rojo_LP008.material.emissiveIntensity = 1;
			this.carro_rojo_LP008.material.emissive.set("#BFBFBF"); //191

			this.bus_LP001 = gltf.scene.getObjectByName("bus_LP001", true);
			this.bus_LP001.material.emissiveIntensity = 1;
			this.bus_LP001.material.emissive.set("#A1A1A1"); //161

			this.tree_large_mesh005 = gltf.scene.getObjectByName("tree_large_mesh005", true); // mat vegetacion
			this.tree_large_mesh005.material.emissiveIntensity = 0;
			// this.tree_large_mesh005.material.emissive.set("#E8E8E8"); // 232
			this.tree_large_mesh005.material.color.set(0xE8E8E8)

		});
		loader.load(modelbackground, (gltf) => {
			gltf.scene.scale.set(0.62, 0.62, 0.62);
			this.add(gltf.scene);
		});
		loader.load(rayos, (gltf) => {
			this.add(gltf.scene);
			this.R_ParadaTecnica = gltf.scene.getObjectByName("R_ParadaTecnica", true);
			this.R_Clasico = gltf.scene.getObjectByName("R_Clasico", true);
			this.R_Hogar = gltf.scene.getObjectByName("R_Hogar", true);
			this.R_Barrio = gltf.scene.getObjectByName("R_Barrio", true);
			this.R_Oficinistas = gltf.scene.getObjectByName("R_Oficinistas", true);
		});
	}

	onAnimate(object, intensity = 6) {
		if (this.animation) {
			this.animation.kill();
		}

		if (this.objectActiveAnimation) {
			this.objectActiveAnimation.material.emissiveIntensity = 1
			this.objectActiveAnimation = null
		}

		if (!object) {
			return
		}

		const newMaterial = object.material.clone();
		object.material = newMaterial;

		this.objectActiveAnimation = object
		// object.material.material.emissive.set("#404040");

		this.animation = gsap.to(object.material, {
			emissiveIntensity: intensity,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
	}

	renderAnimations() { }
}
